import { Box, Button, Switch } from "@mui/material";
import { Link } from "react-router-dom";
import { PRIVATE_PAGES } from "@app/router/pages";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { VisibleEnum } from "types";
import { EXTRA_DATE_FORMAT } from "@constants/index";
import BasicPagination from "@app/components/Pagination";
import { format } from 'date-fns';

import { StyledImage, StyledTableCell } from "./styled";
import { useRecipesLogic } from "./useRecipesLogic";
import { isValidVideoPath } from "@utils/image";

const Recipes = () => {
  const {
    recipesList,
    pagesCount,
    handleChange,
    handleDeleteRecipe,
    handlePagination
  } = useRecipesLogic()

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '20px',
        flexDirection: 'column',
        alignItems: 'flex-end'
      }}
    >
      <Link to={PRIVATE_PAGES.CREATE_RECIPE}>
        <Button variant="contained" color="primary">
          Create Recipe
        </Button>
      </Link>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Image</TableCell>
              <TableCell align="center">TITLE AM</TableCell>
              <TableCell align="center">TITLE En</TableCell>
              <TableCell align="center">TITLE Ru</TableCell>
              <TableCell align="center">READ TIME</TableCell>
              <TableCell align="center">POSTED DATE</TableCell>
              <TableCell align="center">VISIBALITY</TableCell>
              <TableCell align="center">IN HOME</TableCell>
              <TableCell align="center">ACTIONS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {recipesList.map((recip) => {
              // eslint-disable-next-line max-len
              const image = recip?.images?.find(({ isMain }) => isMain)?.url || recip?.images?.length ? recip?.images[0].url : ''

              return (
                <TableRow key={recip.id}>
                  <TableCell align="center">
                    {
                      isValidVideoPath(image) ? (
                        // eslint-disable-next-line jsx-a11y/media-has-caption
                        <video width="80" height="80">
                          <source src={`${process.env.REACT_APP_API_BASE_URL}/${image}`} type="video/mp4" />
                        </video>
                      ) : (
                        <StyledImage
                          alt="product"
                          src={`${process.env.REACT_APP_API_BASE_URL}/${image}`}
                        />
                      )
                    }

                  </TableCell>
                  <TableCell align="center">{recip.titleAm}</TableCell>
                  <TableCell align="center">{recip.titleEn}</TableCell>
                  <TableCell align="center">{recip.titleRu}</TableCell>
                  <TableCell align="center">
                    {recip.minRead}
                    m
                  </TableCell>
                  <TableCell align="center">{format(new Date(recip.postedDate), EXTRA_DATE_FORMAT)}</TableCell>
                  <TableCell align="center">{recip.visible ? VisibleEnum.YES : VisibleEnum.NO}</TableCell>
                  <TableCell>
                    <Switch
                      checked={recip.activeInHome}
                      onChange={() => handleChange(recip)}
                    />
                  </TableCell>
                  <StyledTableCell align="center">
                    <Link to={`/recipes/${recip.id}`}>
                      <Button variant="outlined">
                        Edit
                      </Button>
                    </Link>
                    <Button
                      variant="contained"
                      onClick={() => handleDeleteRecipe(recip.id)}
                    >
                      Delete
                    </Button>
                  </StyledTableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <BasicPagination count={pagesCount} callback={handlePagination} />
    </Box>
  )
};

export default Recipes;
